import { logPush } from './push-diagnostics';

export function triggerWebViewGoldScheme(scheme: string): Promise<void> {
  return new Promise((resolve, reject) => {
    try {
      logPush('info', 'prefetch', `Triggering WebViewGold scheme: ${scheme}`);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.src = scheme;

      document.body.appendChild(iframe);

      setTimeout(() => {
        try {
          document.body.removeChild(iframe);
          logPush('success', 'prefetch', `Scheme trigger completed: ${scheme}`);
          resolve();
        } catch (error) {
          logPush('error', 'prefetch', `Failed to remove iframe: ${error}`);
          resolve();
        }
      }, 500);
    } catch (error) {
      logPush('error', 'prefetch', `Failed to trigger scheme: ${scheme}`, error);
      reject(error);
    }
  });
}

export async function triggerFirebaseTokenFetch(): Promise<void> {
  const scheme = 'getfirebaseplayerid://';
  logPush('info', 'prefetch', 'Triggering Firebase token fetch');

  try {
    await triggerWebViewGoldScheme(scheme);
    logPush('success', 'prefetch', 'Firebase token fetch triggered successfully');
  } catch (error) {
    logPush('error', 'prefetch', 'Failed to trigger Firebase token fetch', error);
    throw error;
  }
}

export async function triggerPushRegistration(): Promise<void> {
  const scheme = 'registerpush://';
  logPush('info', 'notification', 'Triggering push registration');

  try {
    await triggerWebViewGoldScheme(scheme);
    logPush('success', 'notification', 'Push registration triggered successfully');
  } catch (error) {
    logPush('error', 'notification', 'Failed to trigger push registration', error);
    throw error;
  }
}

export function checkWindowToken(): string | null {
  const win = window as any;
  const token = win.firebaseplayerid;

  if (token) {
    logPush('success', 'prefetch', `Token found in window.firebaseplayerid (length: ${token.length})`);
    return token;
  }

  return null;
}
